module.exports = __webpack_public_path__ + "img/500.be9965b9.svg";